import { createFetcher } from '../contexts/Fetcher';
import { apiLicense } from '../resources/api/apiLicense';
import { useContext } from 'react';
import { OrganizationContext } from '../contexts/OrganizationContext';
import { pending } from '../helpers/pending';

const { useGetOrganizationLicenses } = apiLicense;

export const OrganizationAllLicensesFetcher = createFetcher(() => {
  const { organization } = useContext(OrganizationContext);

  const { execute } = useGetOrganizationLicenses(organization ?? void 0);
  return organization ? execute : pending;
});
